import { gql } from '@apollo/client';

export const fetchEmailDetailsInPPC = gql`
  query fetchEmailDetailsInPPC($email: String!) {
    fetchEmailDetails(email: $email) {
      id
      attachments {
        checksum
        contentType
        contentDisposition
        filename
        size
        id
        self
      }
      date
      html
      mailbox
      messageId
      raw
      self
      size
      subject
      text
      from {
        address
        name
      }
      replyTo {
        address
        name
      }
      cc {
        address
        name
      }
      to {
        address
        name
      }
    }
  }
`;
